import { useSyncExternalStore } from "react"
import {
  AIRBYTE_POLLING_INTERVAL_MS,
  getActiveAirbytePollingKeys,
  subscribeAirbytePolling,
} from "~/ui-rtk/utils/airbyte-polling"

/**
 * Returns the RTK Query pollingInterval (ms) for the shared
 * `GET /company-connector` query. Zero when no Airbyte setup is in progress —
 * RTK Query interprets that as "do not poll". As soon as any component starts
 * a setup via `startAirbytePolling`, every subscriber with this interval
 * begins polling at AIRBYTE_POLLING_INTERVAL_MS; RTK Query dedupes so the
 * network sees a single request per tick regardless of subscriber count.
 */
export function useAirbytePollingInterval(): number {
  const count = useSyncExternalStore(
    subscribeAirbytePolling,
    () => getActiveAirbytePollingKeys().length,
    () => 0,
  )
  return count > 0 ? AIRBYTE_POLLING_INTERVAL_MS : 0
}
